import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import styles from "./OrderDetailsNewVersion.module.scss";
import Grid from "@material-ui/core/Grid";
import SharedToolTip from "../../../shared/sharedToolTip/SharedToolTip";

class SpecsRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false,
    };
  }

  handleTooltipOpen = () => {
    this.setState((prevState) => ({
      tooltipOpen: !prevState.tooltipOpen,
    }));
  };

  render() {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {this.props.priceDetails && (
          <Grid
            container
            alignItems="center"
            key={this.props.priceDetails}
            className={`${styles.indent} ${this.props.style}`}
            data-testid={`${this.props.priceDetails}`}
          >
            <Grid item xs={10}>
              <div className={this.props.rowStyle}>
                <span>{this.props.priceDetails}</span>
                {(this.props.tooltipHeader || this.props.tooltipBody) && (
                  <SharedToolTip
                    openTestid="openTooltipId"
                    closeTestid="closeTooltipId"
                    open={this.state.tooltipOpen}
                    closeTooltip={this.handleTooltipOpen}
                    openTooltip={this.handleTooltipOpen}
                    title={this.props.tooltipHeader}
                    body={this.props.tooltipBody}
                  />
                )}
              </div>
            </Grid>
            <Grid item xs={2}>
              <div data-testid={this.props.dataTestId}>{this.props.price}</div>
            </Grid>
          </Grid>
        )}
      </>
    );
  }
}

export default withTranslation("emp")(SpecsRow);
